import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import RouterNav from './RouterNav';

ReactDOM.render(
  <React.StrictMode>
    <RouterNav />
  </React.StrictMode>,
  document.getElementById('root')
);

